import { IPermission, IUserDetail } from '../../library/types/ISecurity'
import { CrudHelper, EditModes, SystemPanel } from '..';
import { getPermission, getUserId } from '../../service/userService';
import { localToUTC } from '../helpers/utils';


export interface ISystemFormHelper {
    securityObject?: string
    //readUrl?: string,
    url?: string,
    primaryKeyEncrypted?: string
    onProcessBegin?(): void,
    onProcessEnd?(): void,
    showCrudMessages?: boolean,
    onPrepare?(): any,
    onRead?(): void,
    onLoad?(data?: any, mode?: EditModes): void;
    onAdd?(): void,
    onRecordUpdated?(mode: EditModes, response: any, closeForm?: boolean): void,
    onError?(error?: any, mode?: EditModes, key?: string): void,
    onEdit?(): void,
    onDelete?(): void,
    clearOnSave?: boolean,
    clearOnDelete?: boolean,
    onClear?(): void,
    onInitialize?(): any,
    AddUrl?: string

}

const showConsoleInfo = false;

export default class SystemFormHelper {

    public static defaultPermission: IPermission = { AddPermission: true, ReadPermission: true, EditPermission: true, DeletePermission: true }

    public static onReadAsync = (options: ISystemFormHelper): Promise<any> => {
        let permission = getPermission(options.securityObject) || SystemFormHelper.defaultPermission;

        return new Promise((resolve, reject) => {
            if (!permission || permission.ReadPermission == undefined) {
                reject(new Error("Permissions not found"));
                return;
            }

            if (!(permission.ReadPermission || permission.EditPermission)) {
                // toast.warning("You dont have read permissions for this form")
                reject(new Error("You dont have permission to perform READ this object"));
                return;
            }

            if (!options.url) {
                reject(new Error("URL Not found / provided"));
                return;
            }

            if (!options.primaryKeyEncrypted) {
                reject(new Error("Primary key not provided"));
                return;
            }

            CrudHelper(
                {
                    url: (options.url) + "/" + options.primaryKeyEncrypted,
                    mode: EditModes.Read,
                    key: options.primaryKeyEncrypted,
                    onSuccess: (response) => resolve(response),
                    onError: (error) => reject(error),
                    showMessage: (options.showCrudMessages ? options.showCrudMessages : true)
                })
        });
    }

    /** */
    public static onAddAsync = (options: ISystemFormHelper): Promise<any> => {
        let permission = getPermission(options.securityObject) || SystemFormHelper.defaultPermission;

        return new Promise((resolve, reject) => {
            if (!permission || permission.AddPermission == undefined) {
                reject(new Error("Permissions not found"));
                return;
            }

            if (!permission.AddPermission) {
                //   toast.warning("You dont have add permissions for this form")
                reject(new Error("You dont have permission to perform ADD on this object"));
                return;
            }

            if (!options.url) {
                reject(new Error("URL Not found / provided"));
                return;
            }



            CrudHelper({
                url: (options.AddUrl || options.url),
                mode: EditModes.Create,
                data: options.onPrepare ? { ...options.onPrepare(), CreatedBy: getUserId(), CreatedDateTime: localToUTC(new Date()) } : null,
                onSuccess: (response) => resolve(response),
                onError: (error) => reject(error),
                showMessage: (options.showCrudMessages ? options.showCrudMessages : true)
            })
        });
    }

    /** */
    public static onEditAsync = (options: ISystemFormHelper): Promise<any> => {
        let permission = getPermission(options.securityObject) || SystemFormHelper.defaultPermission;
        return new Promise((resolve, reject) => {
            if (!permission || permission.EditPermission == undefined) {
                reject(new Error("Permissions not found"));
                return;
            }

            if (!permission.EditPermission) {
                //   toast.warning("You dont have edit permissions for this form")
                reject(new Error("You dont have permission to perform EDIT on this object"));
                return;
            }

            if (!options.url) {
                reject(new Error("URL Not found / provided"));
                return;
            }

            if (!options.primaryKeyEncrypted) {
                reject(new Error("Primary key not provided"));
                return;
            }
            CrudHelper({
                url: (options.url),
                mode: EditModes.Update,
                data: options.onPrepare ? { ...options.onPrepare(), ModifiedBy: getUserId(), ModifiedDateTime: localToUTC(new Date()) } : null,
                key: options.primaryKeyEncrypted,
                onSuccess: (response) => resolve(response),
                onError: (error) => reject(error),
                showMessage: (options.showCrudMessages ? options.showCrudMessages : true)
            })
        });
    }

    /** */
    public static onDeleteAsync = (options: ISystemFormHelper): Promise<any> => {
        let permission = getPermission(options.securityObject) || SystemFormHelper.defaultPermission;
        return new Promise((resolve, reject) => {
            if (!permission || permission.DeletePermission == undefined) {
                reject(new Error("Permissions not found"));
                return;
            }

            if (!permission.DeletePermission) {
                //   toast.warning("You dont have delete permissions for this form")
                reject(new Error("You dont have permission to perform DELETE on this object"));
                return;
            }

            if (!options.url) {
                reject(new Error("URL Not found / provided"));
                return;
            }

            if (!options.primaryKeyEncrypted) {
                reject(new Error("Primary key not provided"));
                return;
            }

            CrudHelper({
                url: ((options.url) + "/" + options.primaryKeyEncrypted),
                mode: EditModes.Delete,
                key: options.primaryKeyEncrypted,
                onSuccess: (response) => resolve(response),
                onError: (error) => reject(error),
                showMessage: (options.showCrudMessages ? options.showCrudMessages : true)
            })
        });
    }

    /** */
    public static onRead = (options: ISystemFormHelper) => {
        if (options.onRead) options.onRead();
        else if (options.url && options.primaryKeyEncrypted) {
            options.onProcessBegin && options.onProcessBegin();
            SystemFormHelper.onReadAsync(options)
                .then((response) => options.onLoad && options.onLoad(response.data))
                .catch((error) => options.onError && options.onError(error, EditModes.Read, ""))
                .finally(() => options.onProcessEnd && options.onProcessEnd());
        }
    }

    /** */
    public static onAdd = (options: ISystemFormHelper, closeForm?: boolean) => {
        if (options.onAdd) options.onAdd();
        else if (options.url) {
            options.onProcessBegin && options.onProcessBegin();
            SystemFormHelper.onAddAsync(options)
                .then((response) => options.onRecordUpdated && options.onRecordUpdated(EditModes.Create, response, closeForm))
                .catch((error) => options.onError && options.onError(error, EditModes.Create, ""))
                .finally(() => options.onProcessEnd && options.onProcessEnd());
        }
    }

    /** */
    public static onEdit = (options: ISystemFormHelper, closeForm?: boolean) => {
        if (options.onEdit) options.onEdit();
        else if (options.url && options.primaryKeyEncrypted) {
            options.onProcessBegin && options.onProcessBegin();
            SystemFormHelper.onEditAsync(options)
                .then((response) => options.onRecordUpdated && options.onRecordUpdated(EditModes.Update, response, closeForm))
                .catch((error) => options.onError && options.onError(error, EditModes.Update, options.primaryKeyEncrypted))
                .finally(() => options.onProcessEnd && options.onProcessEnd());
        }
    }

    /** */
    public static onDelete = (options: ISystemFormHelper, closeForm?: boolean) => {
        if (options.onDelete) options.onDelete();
        else if (options.url && options.primaryKeyEncrypted) {
            options.onProcessBegin && options.onProcessBegin();
            SystemFormHelper.onDeleteAsync(options)
                .then((response) => options.onRecordUpdated && options.onRecordUpdated(EditModes.Delete, response, closeForm))
                .catch((error) => options.onError && options.onError(error, EditModes.Delete, options.primaryKeyEncrypted))
                .finally(() => options.onProcessEnd && options.onProcessEnd());
        }
    }
}